import { OtpId } from 'model/modules/otp/types';
import { FC, useState } from 'react';
import LoginConfirmPhoneContainer from './LoginConfirmPhoneContainer';
import LoginEnterPhoneContainer from './LoginEnterPhoneContainer';

const LoginContainer: FC = () => {
  const [step, setStep] = useState<number>(1);
  const [phoneNumber, setPhoneNumber] = useState<string | null>(null);
  const [otpId, setOtpId] = useState<OtpId | null>(null);

  return (
    <>
      {step === 1 && (
        <LoginEnterPhoneContainer
          goNext={(phone: string, otpId: OtpId) => {
            setStep(2);
            setPhoneNumber(phone);
            setOtpId(otpId);
          }}
        />
      )}
      {step === 2 && otpId !== null && (
        <LoginConfirmPhoneContainer
          goBack={() => setStep(1)}
          phoneNumber={phoneNumber}
          otpId={otpId}
        />
      )}
    </>
  );
};

export default LoginContainer;
